import { Box } from '@chakra-ui/react'

interface OceanProSidebarOverlayProps {
  isActive: boolean
}

const OceanProSidebarOverlay = ({ isActive }: OceanProSidebarOverlayProps) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      borderRadius="8px"
      overflow="hidden"
      pointerEvents="none"
      zIndex={0}
      opacity={isActive ? 1 : 0}
      transition="opacity 0.3s ease"
    >
      {/* Simple darker purple background */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="linear-gradient(180deg, #1e1b4b 0%, #312e81 100%)"
      />
    </Box>
  )
}

export default OceanProSidebarOverlay
